import {useContext} from "react";
import {FormData} from "../components/form-renderer/FormProvider";
import FormTemplateHelpers from '@helpers/form-template-helpers';

const isEqual = (condition, value) => {
    if (typeof value === 'object') {
        const {
            other,
            ...valueNoOther
        } = value;
        const keys = Object.keys(valueNoOther);
        return (value[keys[0]] === condition);
    }

    return condition === value;
}

export default function useFormEvents() {
    let {
        state,
        dispatch,
        findAnswer
    } = useContext(FormData);

    const emitChangesToFields = (field, fieldValue, answerIndex = 0) => {
        let value = fieldValue;

        // Remove 'other' from the value
        if (typeof fieldValue === 'object') {
            const {other, ...rest} = fieldValue;
            value = rest;
        }

        const events = state.events;
        const storedField = FormTemplateHelpers.getFieldById(field.id, state.fields);

        // Find the events object for this field
        /**
         * @property {FormFieldEvent[]} fieldEvents
         */
        const fieldEvents = events.find(({id}) => id === field.id);

        function emitChange(action, valueCondition, target, transformedValue, answerIndex) {
            switch (action) {
                case 'setValue':
                    if ((valueCondition && isEqual(valueCondition, value)) || !valueCondition) {
                        dispatch({
                            type: 'UPDATE_ANSWER',
                            payload: {
                                field: {id: target.id},
                                answerIndex,
                                value: transformedValue
                            }
                        })

                    }
                    break;
                case 'appendAndSetValue':
                    if ((valueCondition && isEqual(valueCondition, value)) || !valueCondition) {
                        dispatch({
                            type: 'APPEND_ANSWER',
                            payload: {
                                field: {id: target.id},
                                answerIndex,
                                value: transformedValue,
                            }
                        });

                        dispatch({
                            type: 'UPDATE_ANSWER',
                            payload: {
                                field: {id: target.id},
                                answerIndex,
                                value: transformedValue
                            }
                        })

                    }
                    break;
                case 'setVisible':
                case 'setHidden':
                case 'setRequired':
                case 'setOptional':
                    let dispatchAction;
                    let dispatchActionInverse;

                    if (action === 'setVisible' || action === 'setHidden') {
                        dispatchAction = action === 'setVisible' ? 'SET_VISIBLE' : 'SET_HIDDEN';
                        dispatchActionInverse = action === 'setVisible' ? 'SET_HIDDEN' : 'SET_VISIBLE';
                    } else {
                        dispatchAction = action === 'setRequired' ? 'SET_REQUIRED' : 'SET_OPTIONAL';
                        dispatchActionInverse = action === 'setRequired' ? 'SET_OPTIONAL' : 'SET_REQUIRED';
                    }

                    console.log(dispatchAction);
                    console.log(dispatchActionInverse);

                    if (valueCondition) {
                        if (isEqual(valueCondition, value)) {
                            dispatch({
                                type: dispatchAction,
                                payload: {
                                    field: {id: target.id},
                                    answerIndex,
                                    value: transformedValue
                                }
                            })
                        } else {
                            dispatch({
                                type: dispatchActionInverse,
                                payload: {
                                    field: {id: target.id},
                                    answerIndex,
                                    value: transformedValue
                                }
                            })
                        }
                    } else {
                        dispatch({
                            type: dispatchAction,
                            payload: {
                                field: {id: target.id},
                                answerIndex,
                                value: transformedValue
                            }
                        })
                    }

                    break;
            }
        }

        if (fieldEvents) {
            const {id, ...actions} = fieldEvents;

            /**
             * e.g. setValue: [
             *      // {FormFieldEventAction}
             * ]
             */
            for (const action in /** @type {FormFieldEventActionType[]} */ actions) {
                if (actions[action].length > 0) {
                    /**
                     * @type {FormFieldEventAction[]} actions
                     */
                    for (const actionElement of actions[action]) {
                        // If the FormFieldEventAction sets a value, transform it to match the target field.
                        // If it has no action, use the original field's value.
                        const transformedValue = FormTemplateHelpers.transformValueToTarget((actionElement.value ? actionElement.value : value), field, actionElement.target);
                        const valueCondition = actionElement?.condition?.equals;

                        if (FormTemplateHelpers.fieldHasRepeatableParent(actionElement.target) && !FormTemplateHelpers.fieldsHaveSameParent(actionElement.target, storedField)) {
                            const indexes = Object.keys(state.values[actionElement.target.id]);

                            for (const index of indexes) {
                                emitChange(action, valueCondition, actionElement.target, transformedValue, index);
                            }
                        } else {
                            emitChange(action, valueCondition, actionElement.target, transformedValue, answerIndex);
                        }

                    }
                }
            }
        }
    }

    return {
        emitChangesToFields
    }
}